module.exports = __webpack_public_path__ + "82830839d6cf3f048185167b9f3ef32e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/helmet-football.png
// module id = 2773
// module chunks = 0